// @flow
import * as React from 'react';
import { VERTICAL_NAMES } from '../../../../common/constants/common';
import FeaturesCars from '../cars';
import FeaturesHomes from '../homes';
import Features from '.';

type Props = {
  verticalName: 'cars' | 'homes' | 'jobs' | 'products',
  description?: string,
  country?: Object,
  verticalProps?: Object,
};

class FeaturesContainer extends React.Component<Props> {
  static defaultProps = {
    verticalProps: null,
    description: null,
    country: null,
  };

  getVerticalFeature() {
    const { verticalName, verticalProps, description, country } = this.props;

    if (!verticalProps) {
      return null;
    }

    switch (verticalName) {
      case VERTICAL_NAMES.cars:
        return (
          <FeaturesCars
            year={verticalProps.year}
            doors={verticalProps.doors}
            mileage={verticalProps.mileage}
            description={description}
          />
        );
      case VERTICAL_NAMES.homes:
        return (
          <FeaturesHomes
            rooms={verticalProps.rooms}
            bathrooms={verticalProps.bathrooms}
            floorArea={verticalProps.floorArea}
            country={country}
            isRTL={country ? country.readingDirection === 'rtl' : false}
          />
        );
      default:
        return null;
    }
  }

  render() {
    if (!this.props.verticalProps) {
      return null;
    }

    const feature = this.getVerticalFeature();

    return feature && <Features>{feature}</Features>;
  }
}

export default FeaturesContainer;



// WEBPACK FOOTER //
// ./app/components/mobile/Features/shared/container.js